<template lang="pug">
  .edit-sub-frequency.narrow-modal-body
    SectionTitle(text="Change Frequency" data-mr-ass="change-freq-modal").app-modal-title
    .row.freq-input
      .xs-12.md-6.md-offset-3
        dropdown.font-small.mr-5(label="Ships Every" v-model="frequency" body-scroll-lock-ignore data-mr-ass="change-freq-dropdown")
          option(v-for="num in frequencies" :value="num" :key="num") {{ num }}

    SubmitButtons(
      submit-text="Save"
      :submit-method="updateSubFrequency"
      :submit-disabled="savingSub"
      cancel-text="Cancel"
      :cancel-method="cancel"
    )

  
</template>

<script>
  import { mapState, mapActions, mapMutations } from "vuex";
  import SubmitButtons from "../../../SubmitButtons";
  import SectionTitle from "../../../SectionTitle";

  export default {
    name: "EditAutoDeliveryFrequencyModal",
    components: {
      SectionTitle,
      SubmitButtons
    },

    computed: {
      ...mapState('subscriptions', [
        'savingSub',
        'subInEdit'
      ]),

      frequencies() {
        return this.subInEdit.product_type_sub_frequencies.split(',');
      },

      frequency: {
        get() {
          return this.subInEdit.frequency;
        },

        set(val) {
          this.setSubInEditFrequency(val);
        }
      }
    },

    methods: {
      ...mapActions('subscriptions', [
        'updateSubscription'
      ]),

      ...mapActions('modal', [
        'hideModal'
      ]),

      ...mapMutations('subscriptions', [
        'clearSubInEdit',
        'setSubInEditFrequency'
      ]),

      updateSubFrequency() {
        var payload = {
          sub_id: this.subInEdit.id,
          changes: {
            frequency: this.subInEdit.frequency
          }
        };

        this.updateSubscription(payload).then(this.cleanUp);
      },

      cleanUp() {
        this.clearSubInEdit();
        this.hideModal();
      },

      cancel() {
        this.cleanUp();
      }
    }
   }
</script>

<style scoped lang="stylus">
  .edit-sub-frequency
    padding-bottom 3em
    
    .freq-input
      margin-bottom 2em

</style>
